import { Component, Input } from '@angular/core';

@Component({
  selector: 'zbp-overview-welcome',
  templateUrl: './overview-welcome.component.html',
  styleUrls: ['./overview-welcome.component.scss'],
  standalone: false
})
export class OverviewWelcomeComponent {
  @Input() name: string;
  @Input() schoolYear: number;

  get schoolYearDisplay(): string {
    return `${this.schoolYear}&ndash;${(this.schoolYear + 1)}`;
  }
}
